import React from 'react';
import { useSelector } from 'react-redux';
import { Close } from '@material-ui/icons';

import { useCartStandaloneProvider } from './cart-standalone-provider/cart-standalone-provider';
import { useNotificationProvider } from '../../../components/notifications/NotificationProvider';
import { STANDALONE_CART_TYPE } from '../../../utils/consts';
import CartStandaloneTabs from './cart-standalone-tabs/cart-standalone-tabs';
import { FilledButton } from '../../../components';
import IconCopy from '../../../assets/icons/Copy';

import './cart-standalone-side-bar.scss';

const CartStandaloneSideBar = ({ sidebarAnimation, onHideStandaloneCartSidebar, onCreateStandaloneCartSidebar, isLoading = false
}) => {
      const {
            selectedTab,
            navigateToStandaloneClientTab,
            standaloneCartProducts,
            standaloneCartRecoveryUrl
      } = useCartStandaloneProvider();

      const { showToast } = useNotificationProvider();
      const standaloneCartUser = useSelector((state) => state.user?.standaloneCartUser);

      let customerEmail = "";
      let customerName = "";

      if (standaloneCartUser) {
            const { email, customer } = standaloneCartUser;
            customerName = typeof customer === 'string' ? customer : customer?.displayName || '';
            customerEmail = email || '';
      }

      const copyToClipboard = () => {
            if (standaloneCartRecoveryUrl) {
                  navigator.clipboard.writeText(standaloneCartRecoveryUrl)
                        .then(() => {
                              showToast({
                                    description: 'Link copied to clipboard',
                                    type: 'info',
                              });
                        })
                        .catch((error) => {
                              console.error('Failed to copy:', error);
                              showToast({
                                    description: 'Failed to copy link',
                                    type: 'error',
                              });
                        });
            }
      };

      return (
            <div className={`cart-standalone-sidebar-container ${sidebarAnimation}`}>
                  {isLoading && (
                        <div className="cart-standalone-loading-overlay">
                              <div className="spinner" />
                        </div>
                  )}

                  <div className="cart-standalone-sidebar-header">
                        <div className="title-container">
                              <p className="customer-name-title">Standalone Cart</p>
                              {selectedTab === STANDALONE_CART_TYPE.INFO ||
                              (selectedTab === STANDALONE_CART_TYPE.CART && standaloneCartRecoveryUrl) ? (
                                    <button onClick={onHideStandaloneCartSidebar}>
                                          <Close />
                                    </button>
                              ) : (
                                    <div className="save-back-container">
                                          <button
                                                className="back-button"
                                                onClick={navigateToStandaloneClientTab}
                                          >
                                                Back
                                          </button>
                                          <FilledButton
                                                className="button"
                                                style={{ width: '80px', height: '30px', alignSelf: 'center' }}
                                                disabled={standaloneCartProducts.length === 0}
                                                onClick={onCreateStandaloneCartSidebar}
                                          >
                                                Create
                                          </FilledButton>
                                    </div>
                              )}
                        </div>

                        <div className="customer-container">
                              {standaloneCartUser && !standaloneCartUser.anonymousMode && (
                                    <>
                                          <p className="customer-info left">{customerName}</p>
                                          <p className="customer-info left">{customerEmail}</p>
                                    </>
                              )}
                              {standaloneCartUser?.anonymousMode && (
                                    <p className="customer-info left">Unassigned cart</p>
                              )}
                        </div>
                  </div>

                  <div
                        className={`copy-link-action ${!standaloneCartRecoveryUrl ? 'copy-link-action-disabled' : ''}`}
                        onClick={copyToClipboard}
                  >
                        <IconCopy />
                        <p>Copy Standalone Cart</p>
                  </div>

                  <div className={`call-details-sidebar-wrapper${selectedTab === STANDALONE_CART_TYPE.INFO ? ' scroll' : ''}`}>
                        <CartStandaloneTabs />
                  </div>
            </div>
      )
}

export default CartStandaloneSideBar
